import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../lib/request";
import { unwrapHotelSearchList } from "../../lib/utils/hotelSearchMappers";

export const searchBrandHotels = createAsyncThunk(
  "hotels/brandSearch",
  async (
    params = {},
    { rejectWithValue }
  ) => {
    try {

      const {
        query = "",
        page = 0,
        size = 100
      } = params;

      let url = `/authn/brands/search?page=${page}&size=${size}`;

      if (query && query.trim() !== "") {
        url += `&q=${encodeURIComponent(query.trim())}`;
      }


      const response = await get(
        url,
        null,
        { skipAuth: false }
      );

      return unwrapHotelSearchList(response);

    } catch (error) {

      console.error("Brand API error:", error);

      return rejectWithValue(error.message);

    }
  }
);


export const searchHotels = createAsyncThunk(
  "hotels/search",
  async (query, { rejectWithValue }) => {
    try {
      const response = await get(
        `/authn/hotels/search?q=${encodeURIComponent(query)}`,
        null,
        { skipAuth: true }
      );
      return unwrapHotelSearchList(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const hotelsSlice = createSlice({
  name: "hotels",
  initialState: {
    brands: [],
    hotels: [],
    loadingBrands: false,
    loadingHotels: false,
    error: null,
  },
  reducers: {
    clearHotels: (state) => {
      state.hotels = [];
    },
    clearBrands: (state) => {
      state.brands = [];
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(searchBrandHotels.pending, (state) => {
        state.loadingBrands = true;
      })
      .addCase(searchBrandHotels.fulfilled, (state, action) => {
        state.loadingBrands = false;
        state.brands = action.payload || [];
      })
      .addCase(searchBrandHotels.rejected, (state) => {
        state.loadingBrands = false;
      })


      .addCase(searchHotels.pending, (state) => {
        state.loadingHotels = true;
      })
      .addCase(searchHotels.fulfilled, (state, action) => {
        state.loadingHotels = false;
        state.hotels = action.payload || [];
      })
      .addCase(searchHotels.rejected, (state, action) => {
        state.loadingHotels = false;
        state.error = action.payload;
      });
  },
});

export const { clearHotels, clearBrands } = hotelsSlice.actions;
export default hotelsSlice.reducer;
